/**
 * Capitalizes the first letter of a string, making the rest of the string lowercase.
 *
 * @param name - The string for `icon_name` property.
 */
export function capitalizeIconName(name: string): string {
	if (!name) {
		return "";
	}

	const joined = name.split(" ").join("");

	return joined.charAt(0).toUpperCase() + joined.slice(1);
}
